import { useState, useEffect } from "react";
import { format } from "date-fns";
import { DateRange } from "react-day-picker";
import { Button, Popover, PopoverContent, PopoverTrigger } from "@reactive-resume/ui";
import { CalendarBlankIcon } from "@phosphor-icons/react";
import { cn } from "@reactive-resume/utils";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";

type SelectRangeDateProps = {
  className?: string;
  value?: DateRange; // Valeur contrôlée depuis le parent
  onChange?: (value: DateRange | undefined) => void;
};

export const SelectRangeDate = ({ className, value, onChange }: SelectRangeDateProps) => {
  const [date, setDate] = useState<DateRange | undefined>(value);

  // Synchronise la valeur si le parent change (ex: clic sur un bouton)
  useEffect(() => {
    setDate(value);
  }, [value]);

  const handleSelect = (selected: DateRange | undefined) => {
    setDate(selected);
    if (onChange) onChange(selected);
  };

  return (
    <div className={cn("relative", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={cn(
              "h-10 w-[280px] justify-start border-admin-border bg-admin-surface text-left font-normal text-admin-text-primary hover:bg-admin-surface-hover hover:text-admin-text-primary",
              !date && "text-admin-text-muted",
            )}
          >
            <CalendarBlankIcon size={18} className="mr-2" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, "dd/MM/yyyy")} - {format(date.to, "dd/MM/yyyy")}
                </>
              ) : (
                format(date.from, "dd/MM/yyyy")
              )
            ) : (
              <span>Sélectionner une période</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto border-admin-border bg-admin-surface p-0" align="start">
          <DayPicker
            mode="range"
            selected={date}
            onSelect={handleSelect}
            numberOfMonths={2}
            className="bg-admin-surface p-3 text-admin-text-primary"
            styles={{
              day_button: { color: "var(--text-admin-text-secondary)" },
              button_previous: { color: "var(--text-admin-text-secondary)" },
              button_next: { color: "var(--text-admin-text-secondary)" },
            }}
            modifiersStyles={{
              selected: {
                backgroundColor: "var(--bg-admin-primary)",
                color: "var(--text-admin-text-primary)",
              },
              range_start: {
                backgroundColor: "var(--bg-admin-primary)",
                color: "var(--text-admin-text-primary)",
              },
              range_end: {
                backgroundColor: "var(--bg-admin-primary)",
                color: "var(--text-admin-text-primary)",
              },
              range_middle: {
                backgroundColor: "var(--bg-admin-primary)",
                color: "var(--text-admin-text-primary)",
              },
              today: { color: "var(--text-admin-primary)" },
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
